'use client'

import { SearchWidget } from '@/components/features/reservation/SearchWidget'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog'

interface SearchModalProps {
	isOpen: boolean
	onClose: () => void
	onSearch?: () => void
}

export function SearchModal({ isOpen, onClose, onSearch }: SearchModalProps) {
	const handleSearch = () => {
		onClose()
		onSearch?.()
	}

	return (
		<Dialog
			open={isOpen}
			onOpenChange={onClose}
		>
			<DialogContent className='sm:max-w-[800px] bg-transparent border-0 shadow-none p-0'>
				<DialogHeader className='sr-only'>
					<DialogTitle>Modificar Reserva</DialogTitle>
				</DialogHeader>
				<SearchWidget onSearch={handleSearch} />
			</DialogContent>
		</Dialog>
	)
}
